import { render, staticRenderFns } from "./CustomerInfoDependentCustomers.vue?vue&type=template&id=01639416"
import script from "./CustomerInfoDependentCustomers.vue?vue&type=script&lang=js"
export * from "./CustomerInfoDependentCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports